import { RAIL_COLOR, RAIL_HEIGHT, RAIL_INSET_SHADOW } from '../constants'
import type { RenderLinesProps } from './types'
import type { KnobLine } from '../types'
import type { Ref } from 'vue'
import { renderStepLines } from './stepLines'

export const renderRail = (lines: Ref<KnobLine[]>, props: RenderLinesProps) => {
  const showStepLines = props.range.step ? (props.range.appearance?.showSteps ?? true) : false;
  return (
    <div class="absolute left-0 top-0 w-full">
      {showStepLines ? renderStepLines(lines, props) : null}
      <div
        class="rounded-l rounded-r"
        style={{
          position: 'absolute',
          left: 0,
          top: 0,
          bottom: 0,
          marginBottom: 'auto',
          marginTop: 'auto',
          width: '100%',
          height: RAIL_HEIGHT + 'px',
          background: RAIL_COLOR,
          boxShadow: RAIL_INSET_SHADOW
        }}
      />
    </div>
  )
}
